<template>
    <div>
        <div class="cashier g-bs-bb g-tc">
            <h3 class="title">
                {{ $pageLanguage.title }}
                <i class="close" @click="handleClose"></i>
            </h3>
            <div class="info_goods g-tl">
                {{ $pageLanguage.goods }}<span class="info_content g-break">{{pageData.productName}}</span>
            </div>
            <div class="info_order g-tl">
                {{ $pageLanguage.money }}<span class="info_content g-break">{{ $pageLanguage.unit }}{{pageData.displayAmount}}</span>
            </div>
            <div class="pay_way_list">
                <div
                    class="item_pay_way g-flex g-ai-c"
                    v-for="(item, index) in pageData.payWays"
                    :key="item.iconUrl + index"
                    @click="cIndex = index">
                    <img class="pay_way_icon" :src="item.iconUrl" :alt="'pay_way_icon' + index">
                    <span v-if="item.styleType === 1 || item.styleType === '1'" class="g-m-l-5">{{item.payWayName}}{{ $pageLanguage.wayName }}</span>
                    <span class="pay_way_select" v-show="cIndex === index"></span>
                </div>
            </div>
            <button class="btn_pay" @click="handleBtnPay">{{ $pageLanguage.payBtnText }} {{ $pageLanguage.unit }}{{pageData.displayAmount}}</button>
        </div>
        <confirmPayment :baseInfo='baseInfo' ref='confirmPayment'/>
    </div>
</template>

<script>
export default {
    name: 'cashier',
    data () {
        return {
            pageData: {}, // 请求到的页面数据
            cIndex: 0, // 当前选中的支付方式
            queryParams: {}, // 支付所需参数
            baseInfo: {} // 传入框内参数
        }
    },
    computed: {
        $pageLanguage () {
            return this.$language.page.cashier
        }
    },
    created () {
        this.queryParams.orderId = this.$getQueryString('orderId')
        this.getListPayWay()
    },
    mounted () {
        if (sessionStorage[this.queryParams.orderId]) {
            this.handleShowConfirm()
            sessionStorage.removeItem(this.queryParams.orderId)
        }
    },
    methods: {
        // 获取支付方式列表
        getListPayWay () {
            let params = { orderId: this.queryParams.orderId }
            this.$apis.listPayWay(params).then(res => {
                if (res.code === '2000') {
                    this.pageData = res.data
                    if (this.pageData.displayAmount) this.pageData.displayAmount = (this.pageData.displayAmount * 1).toFixed(2)
                }
            })
        },
        // 立即支付
        handleBtnPay () {
            this.$Toast.loading({
                loadingType: 'spinner',
                message: this.$pageLanguage.loadingText,
                duration: 0
            })
            this.handleCreateSwitchOrder()
        },
        // 获取支付令牌/创建订单
        handleCreateSwitchOrder () {
            let params = { orderId: this.queryParams.orderId }
            this.$apis.createSwitchOrder(params).then(res => {
                if (res.code === '2000') {
                    let sdkParams = {
                        payWayId: this.pageData.payWays[this.cIndex].payWayId,
                        appId: res.data.payCenterAppId,
                        notifyUrl: res.data.notifyUrl,
                        merchantId: res.data.payCenterMerchantId,
                        bizTradeId: res.data.orderId,
                        amount: res.data.amount,
                        currency: res.data.currency || 'CNY',
                        goodsDesc: res.data.productDesc,
                        orderToken: res.data.orderToken
                    }
                    if (window.payH5sdk && window.payH5sdk !== null) {
                        if (sdkParams.payWayId === 1) sessionStorage[this.queryParams.orderId] = 'weixin_goback'
                        else if (sessionStorage[this.queryParams.orderId]) sessionStorage.removeItem(this.queryParams.orderId)
                        window.payH5sdk(false, sdkParams, data => {
                            if (data.status) {
                                // $jsBridge.call('web_openOutsideLink', { url: data.url }) // 给客户端外链
                                this.handleShowConfirm()
                            } else this.$Toast(data.message)
                        })
                    }
                } else this.$Toast(res.message)
                this.$Toast.clear()
            }).catch(err => {
                console.log(err)
                this.$Toast.clear()
            })
        },
        // 弹出确认支付框
        handleShowConfirm () {
            this.baseInfo = JSON.parse(JSON.stringify(this.queryParams))
            this.$refs.confirmPayment.isShow = true
        },
        // 关闭收银台
        handleClose () {
            $jsBridge.call('web_closeWindow')
        }
    }
}
</script>
<style lang="less" scoped>
@import './index.less';
</style>
